// *** Angular
import { Component, OnInit } from '@angular/core';

@Component({
   selector: 'app-manage-repositories',
   templateUrl: './manage-repositories.component.html',
   styleUrls: ['./manage-repositories.component.scss'],
})
export class ManageRepositoriesComponent implements OnInit {
   constructor() {}

   ngOnInit(): void {}
}
